export enum RootPaths {
  BOOKING_ROOT = 'booking',
  CHECK_IN_ROOT = 'check-in',
  SITE_SEARCH_ROOT = 'search',
  SELECT_LANGUAGE_ROOT = 'select-language',
  PLUS_ROOT = 'my-finnair-plus',
  OND_MARKETING_LANDING_ROOT = 'flights',
  FINNAIR_HOLIDAYS = 'aurinkomatkat',
  MANAGE_BOOKING_ROOT = 'manage',
  DISRUPTION_ROOT = 'manage/disruption',
  CANCEL_ROOT = 'manage/cancel',
  INVOLUNTARY_CANCEL_ROOT = 'manage/disruption/cancel',
  REACCOMMODATION_ROOT = 'manage/disruption-rebooking',
  ONE_UPGRADE_ROOT = 'manage/upgrade',
  VOLUNTARY_CHANGE_ROOT = 'manage/flight-change',
  TIMETABLE_ROOT = 'timetables',
  REFUNDS = 'refunds',
  CORPORATE = 'corporate',
  TRAVEL_READY = 'travel-ready',
}

export const ROUTER_LANG_PARAM = 'lang';

export const UTM_PARAMS = [
  'utm_source',
  'utm_campaign',
  'utm_medium',
  'utm_term',
  'utm_content',
  'utm_id',
  'gclid',
  'gbraid',
  'wbraid',
  'gclsrc',
  'ds_aid',
  'ds_e_ca_id',
  'ds_e_ag_id',
  'ds_e_ad_id',
  'ds_e_ca_name',
  'ds_e_ag_name',
  'ds_e_ad_name',
  'ds_sig',
  'ds_dest_url',
  'fbclid',
  'ad_id',
  'adset_id',
  'campaign_id',
  'ad_name',
  'adset_name',
  'campaign_name',
  'placement',
  'site_source_name',
  'dclid',
  'gad_source',
  'gad_campaignid',
  'awc',
];

export enum CampaignTagToLabelKey {
  'fcomCampaignSpecial' = 'campaignPrice',
  'fcomCampaignFlash' = 'flashSaleOffer',
  'fcomCampaignBlackFriday' = 'blackFridayOffer',
  'fcomCampaignFinnairPlus' = 'finnairPlusOffer',
  'fcomCampaignCode' = 'campaignCodeOffer',
}

export const FINNISH_SITES = ['fi-fi', 'fi-sv', 'fi-en'];

export const ORIGIN_SELECTOR_CONFIG: Record<string, string[]> = {
  DE: ['BER', 'DUS', 'HAM', 'FRA', 'MUC', 'STR', 'HAJ'],
  CH: ['ZRH', 'GVA'],
  AT: ['VIE', 'INN', 'SZG'],
  EE: ['TLL', 'TAY', 'URE'],
  LV: ['RIX'],
  LT: ['VNO'],
  PL: ['WAW', 'GDN', 'KRK', 'WRO'],
  HU: ['BUD'],
  FR: ['PAR', 'NCE', 'BOD', 'LYS', 'MRS', 'TLS'],
  IT: ['MIL', 'ROM', 'VCE', 'VRN', 'BLQ', 'NAP'],
  ES: ['MAD', 'BCN', 'AGP', 'ALC', 'BIO', 'VLC', 'LCG', 'TCI', 'LPA'],
  PT: ['LIS', 'OPO', 'FAO', 'FNC'],
  US: ['NYC', 'LAX', 'CHI', 'DFW', 'SEA', 'MIA'],
  JP: ['TYO', 'OSA', 'FUK', 'NGO', 'CTS'],
  SE: ['STO', 'GOT', 'UME'],
  NO: ['OSL', 'BGO', 'TRD', 'BOO', 'TOS', 'KKN', 'SVG'],
  GB: ['LON', 'EDI', 'MAN'],
  DK: ['CPH', 'BLL'],
  AU: ['SYD', 'MEL'],
};

export const NON_EUROPE_SITES = [
  'us-en',
  'ca-en',
  'ca-fr',
  'sg-en',
  'th-en',
  'in-en',
  'kr-en',
  'kr-ko',
  'cn-en',
  'cn-zh',
  'hk-en',
  'hk-zh',
  'jp-en',
  'jp-ja',
  'au-en',
];

export const BUS_CONNECTION_LOCATION_CODES = ['TKU', 'TMP', 'XTP', 'XTZ'];
export const RAIL_AND_FLY_LOCATION_CODES = ['QYG'];
export const EUROPEAN_UNION_COUNTRIES = [
  'FI', // Finland
  'AT', // Austria
  'BE', // Belgium
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FR', // France
  'DE', // Germany
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'NL', // The Netherlands
  'NO', // Norway
  'PL', // Polish
  'ES', // Spain
  'SE', // Sweden
];
export const INPUT_DEBOUNCE_TIME = 500;
